
import { auth, invoiceBaseURL } from "../Utility";
import axios from 'axios'


// invoice
export const invoiceAxiosInstance = axios.create({
  baseURL: invoiceBaseURL(),
  headers: { 'Content-Type': 'application/json' },
});

// interceptors invoice

invoiceAxiosInstance.interceptors.request.use(
  (config) => {
    const token = getAdminToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// only admin
function getAdminToken() {
  return auth("admin")?.token;
}

// invoice APICALL
export const INVOICE_APICALL = async (endPoint = '', method = "GET", value = null) => {
  try {
    const response = await invoiceAxiosInstance({
      method: method,
      url: endPoint,
      data: value,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};